import { render } from "./ItemList.vue?vue&type=template&id=43100fcc&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"

import "./ItemList.vue?vue&type=style&index=0&id=43100fcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43100fcc"

export default script